import { ConfigService } from '@rxap/config';

/**
 * Whether the Request API integration is configured for this deployment.
 * Mirrors the existing bare `api.iirds.enabled` reads in `ingestGuard` and
 * `withIirdsFetch` (missing key = disabled) — when disabled, the "Request
 * API Server" upload option is hidden and its route is blocked.
 */
export function isRequestApiEnabled(configService: Pick<ConfigService, 'get'>): boolean {
  return !!configService.get('api.iirds.enabled');
}
